import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { Button, type ButtonProps } from './button'

const fieldTriggerVariants = cva('rounded-[10px] font-normal shadow-none', {
  variants: {
    size: {
      sm: 'h-9 px-3',
      default: 'h-10 px-3.5',
      lg: 'h-11 px-3',
    },
    placeholder: {
      true: 'text-placeholder-foreground enabled:hover:bg-background enabled:hover:text-placeholder-foreground enabled:active:bg-background dark:enabled:hover:bg-card dark:enabled:active:bg-card',
      false: '',
    },
    warning: {
      true: 'border-status-warning-border',
      false: '',
    },
  },
  defaultVariants: {
    size: 'default',
    placeholder: false,
    warning: false,
  },
})

export type FieldTriggerProps = Omit<ButtonProps, 'size' | 'placeholder'> &
  VariantProps<typeof fieldTriggerVariants>

function FieldTrigger({
  className,
  placeholder = false,
  size = 'default',
  warning = false,
  ...props
}: FieldTriggerProps) {
  return (
    <Button
      data-slot="field-trigger"
      data-placeholder={placeholder ? 'true' : 'false'}
      data-warning={warning ? 'true' : 'false'}
      variant="outline"
      className={cn(fieldTriggerVariants({ size, placeholder, warning }), className)}
      {...props}
    />
  )
}

export { FieldTrigger, fieldTriggerVariants }
